export const isTesting = () => window && (window as any).Cypress;

export const isProduction = () => process.env['NX_WEB_FIREBASE_PROJECT_ID'] === 'mezo-prod';
export const isQA = () => process.env['NX_WEB_FIREBASE_PROJECT_ID'] === 'reshub-qa';
